module.exports = __webpack_public_path__ + "img/160.22a708d9.png";